import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MathUtilities {
    standardDeviation(values: number[]): number {
        const count = values.length;
        if (count === 0) {
            return 0;
        }
        const mean = values.reduce((b, a) => b + a, 0.0) / count;
        const sumOfSquaredDifferences = values.reduce(
            (total, value) => total + Math.pow(value - mean, 2),
            0.0
        );
        return Math.sqrt(sumOfSquaredDifferences / count);
    }

    standardError(values: number[]): number {
        if (values.length === 0) {
            return 0;
        }
        return this.standardDeviation(values) / Math.sqrt(values.length);
    }

    limitDigitsAfterDecimal(num: number, digitsAfterDecimalCount: number) {
        const integer = Math.floor(num);
        const decimal = parseFloat(
            (num - integer).toPrecision(digitsAfterDecimalCount)
        );
        return integer + decimal;
    }

    // This function performs the calculation of normal cumulative distribution
    // The formula and constants come from https://www.math.ucla.edu/~tom/distributions/normal.html
    // NOTE: This only gives 2 digits of accuracy
    normalCumulativeDistribution(
        x: number,
        mean: number,
        standardDeviation: number
    ) {
        const zValue = (x - mean) / standardDeviation;

        const t = 1 / (1 + 0.2316419 * Math.abs(zValue));

        const d = 0.3989423 * Math.exp((-zValue * zValue) / 2);

        let prob =
            d *
            t *
            (0.3193815 +
                t *
                    (-0.3565638 +
                        t * (1.781478 + t * (-1.821256 + t * 1.330274))));

        if (zValue > 0) {
            prob = 1 - prob;
        }

        prob = Math.round(100 * prob) / 100;

        return prob;
    }
}
